import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import type { GetPeopleCountRes, GetPeopleExportParams, GetPeopleExportRes, GetPeopleListParams, GetPeopleListRes } from './type';
export const getPeopleList = async (params: GetPeopleListParams): Promise<GetPeopleListRes> => {
  const res = await apiClient.GET('/v2/people-registry/people', {
    params: {
      query: params
    }
  });
  return getDataOrThrowApiError(res);
};
export const getPeopleCount = async (): Promise<GetPeopleCountRes> => {
  const res = await apiClient.GET('/v2/people/count');
  return getDataOrThrowApiError(res);
};
export const getPeopleExport = async (params: GetPeopleExportParams): Promise<GetPeopleExportRes> => {
  const res = await apiClient.GET('/v2/people-csv/all-member', {
    params: {
      query: {
        ...params,
        mode: 'view',
        encoding: 'UTF-8'
      }
    }
  });
  return getDataOrThrowApiError(res);
};